/** Tasks sahifasi lug'ati (ru). */
export default {
  title: "Задачи",
  myReminders: "Мои напоминания",
  subtitle: "Мои напоминания · {{overdue}} просрочено · {{today}} сегодня · {{upcoming}} предстоит",
  subtitleFor: "{{name}} · {{overdue}} просрочено · {{today}} сегодня · {{upcoming}} предстоит",
  addReminder: "Добавить напоминание",
  sort: "Сортировка: по сроку",
  chips: { all: "Все", expiry: "Срок CDL / медсправки" },
  loadFailed: "Не удалось загрузить напоминания.",
  empty: {
    title: "Напоминаний нет",
    desc: "Добавьте напоминание из профиля водителя или кнопкой выше. Напоминания об истечении CDL и медкарты создаются автоматически.",
  },
  upcoming: "Предстоящие",
  toast: {
    snoozed: "Отложено до {{when}}",
    reopened: "Открыто заново",
    updateFailed: "Не удалось обновить напоминание",
    added: "Напоминание добавлено",
    addFailed: "Не удалось добавить напоминание",
  },
  completedToday: "Выполнено сегодня",
  late: {
    days_one: "просрочено на {{count}} день",
    days_few: "просрочено на {{count}} дня",
    days_many: "просрочено на {{count}} дней",
    days_other: "просрочено на {{count}} дней",
    hours_one: "просрочено на {{count}} час",
    hours_few: "просрочено на {{count}} часа",
    hours_many: "просрочено на {{count}} часов",
    hours_other: "просрочено на {{count}} часов",
    justNow: "только что",
  },
  zone: { tashkent: "Ташкент" },
  assigneeLabel: "Ответственный", assigneeAll: "Задачи всех",
  assigneeChip: "Задачи: {{name}}", assigneeChipUnknown: "Задачи выбранного сотрудника",
  snooze: {
    button: "Отложить",
    hour: "1 час",
    tomorrow: "Завтра 9:00",
    nextMonday: "Следующий понедельник 9:00",
    custom: "Своё время ({{zone}})",
    set: "Задать",
  },
  add: {
    title: "Добавить напоминание",
    desc: "Напоминание появится в ваших Задачах и в профиле водителя.",
    driver: "Водитель",
    change: "Изменить",
    searchPlaceholder: "Поиск по имени или телефону",
    searching: "Поиск…",
    noDrivers: "Водители не найдены",
    type: "Тип",
    due: "Срок ({{zone}})",
    note: "Заметка",
    notePlaceholder: "Перезвонить по вакансии Northline",
    driverTime: "Время водителя:",
    chooseDriver: "Выберите водителя.",
    chooseDateTime: "Выберите дату и время.",
  },
};
